import React from 'react';
import { Star, ExternalLink, MapPin, Calendar } from 'lucide-react';
import { testimonials, tvInterview, engineerInfo } from '../../mock';
import { Card, CardContent } from '../ui/card';
import { Badge } from '../ui/badge';

const ProofSection = () => {
  return (
    <section id="depoimentos" className="py-12 sm:py-16 bg-white">
      <div className="container mx-auto px-4 sm:px-6">
        <div className="max-w-3xl mx-auto text-center mb-10">
          <h2 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-[#073A40] mb-4">
            O Que Nossos Clientes Dizem
          </h2>
          <p className="text-xl sm:text-2xl text-[#06323B] font-medium">
            Experiência comprovada e reconhecimento profissional
          </p>
        </div>

        <div className="max-w-5xl mx-auto mb-12">
          <Card className="p-6 sm:p-8 bg-gradient-to-br from-[#073A40] to-[#06323B] border-2 border-[#A69076]/50 shadow-xl">
            <div className="flex flex-col lg:flex-row items-center gap-6 sm:gap-8">
              <div className="relative w-full lg:w-80 h-64 sm:h-80 bg-black/40 rounded-xl overflow-hidden flex-shrink-0">
                <video 
                  className="w-full h-full object-cover"
                  controls
                  playsInline
                >
                  <source src={engineerInfo.interviewVideo} type="video/mp4" />
                  Seu navegador não suporta vídeos.
                </video>
              </div>
              
              <div className="flex-1 text-center lg:text-left">
                <div className="flex items-center justify-center lg:justify-start gap-2 mb-3">
                  <Badge className="bg-[#A69076] text-white border-0">
                    {tvInterview.channel}
                  </Badge>
                  <Badge className="bg-[#A69076] text-white border-0">
                    {tvInterview.program}
                  </Badge>
                </div>
                <h3 className="text-2xl sm:text-3xl font-bold mb-4 text-white">
                  Entrevista na TV Futuro
                </h3>
                <p className="text-[#F2F2F2] mb-6 leading-relaxed text-base sm:text-lg">
                  {tvInterview.description}
                </p>
                <div className="flex items-center justify-center lg:justify-start gap-2 text-sm text-[#A69076]">
                  <ExternalLink size={16} />
                  <span>Assista à entrevista completa</span>
                </div>
              </div>
            </div>
          </Card>
        </div>

        <div className="flex items-center justify-center gap-4 mb-8 p-6 bg-white rounded-xl max-w-2xl mx-auto border-2 border-[#A69076]/30 shadow-lg">
          <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M44 24C44 35.0457 35.0457 44 24 44C12.9543 44 4 35.0457 4 24C4 12.9543 12.9543 4 24 4C35.0457 4 44 12.9543 44 24Z" fill="#4285F4"/>
            <path d="M33.9583 19.375L32.5833 18L24 26.5833L19.4167 22L18 23.4167L24 29.4167L33.9583 19.375Z" fill="white"/>
          </svg>
          <div>
            <div className="flex items-center gap-2 mb-1">
              <span className="text-3xl font-bold text-[#073A40]">5.0</span>
              <div className="flex">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} className="text-[#FBBC04] fill-[#FBBC04]" size={24} />
                ))}
              </div>
            </div>
            <p className="text-base text-[#06323B] font-semibold">
              Avaliações no Google
            </p>
          </div>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {testimonials.map((testimonial) => (
            <Card key={testimonial.id} className="bg-white border-2 border-[#A69076]/30 hover:border-[#A69076] transition-all duration-300 hover:shadow-xl">
              <CardContent className="p-6">
                <div className="flex items-center justify-between mb-4">
                  <div className="flex gap-1">
                    {[...Array(testimonial.rating)].map((_, i) => (
                      <Star key={i} className="text-[#FBBC04] fill-[#FBBC04]" size={18} />
                    ))}
                  </div>
                  <svg width="24" height="24" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M44 24C44 35.0457 35.0457 44 24 44C12.9543 44 4 35.0457 4 24C4 12.9543 12.9543 4 24 4C35.0457 4 44 12.9543 44 24Z" fill="#4285F4"/>
                    <text x="24" y="32" fontSize="24" fill="white" textAnchor="middle" fontWeight="bold">G</text>
                  </svg>
                </div>
                
                <p className="text-[#06323B] mb-4 text-base leading-relaxed">
                  "{testimonial.text}"
                </p>
                
                <div className="border-t border-[#A69F97]/30 pt-4">
                  <p className="font-bold text-[#073A40] text-base">
                    {testimonial.name}
                  </p>
                  <p className="text-sm text-[#A69076] mb-1">
                    {testimonial.service}
                  </p>
                  <div className="flex items-center gap-4 text-xs text-[#A69F97]">
                    <span className="flex items-center gap-1">
                      <MapPin size={12} />
                      {testimonial.location}
                    </span>
                    <span className="flex items-center gap-1">
                      <Calendar size={12} />
                      {testimonial.date}
                    </span>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProofSection;
